export const supportCategories = [
  {
    id: 'report-bullying',
    title: 'Report bullying',
    description: 'Official reporting channels for bullying involving students at Ministry of Education Malaysia schools.',
    resources: [
      {
        name: 'KPM Bullying Complaint Portal',
        audience: 'For bullying involving students in KPM schools.',
        description: 'Experiencing or witnessing bullying at a KPM school? Submit a complaint through the Ministry of Education Malaysia’s official bullying complaint channel.',
        note: 'This channel is specifically for bullying among students in KPM schools. Other situations may need a different reporting channel.',
        details: [
          'Telephone: 03-8884 9325',
          'Phone / WhatsApp: 014-800 9325'
        ],
        actions: [
          {
            label: 'Visit Official Complaint Portal',
            href: 'https://aduanbuli.moe.gov.my/',
            type: 'external',
            primary: true
          },
          {
            label: 'Alternative Complaint Portal',
            href: 'https://moe.spab.gov.my/',
            type: 'external'
          },
          {
            label: 'Call 03-8884 9325',
            href: 'tel:+60388849325',
            type: 'phone'
          },
          {
            label: 'Call / WhatsApp 014-800 9325',
            href: 'https://wa.me/60148009325',
            type: 'whatsapp'
          }
        ],
        references: [
          {
            label: 'MOE official bullying information',
            href: 'https://www.moe.gov.my/aduan-buli-kpm'
          }
        ]
      }
    ]
  },
  {
    id: 'immediate-help',
    title: 'Get immediate help',
    description: 'Emergency assistance and urgent emotional support.',
    resources: [
      {
        name: 'Emergency Services',
        audience: 'For immediate danger, serious injury, or an urgent medical emergency.',
        description: 'If you or someone else is in immediate danger, contact Malaysia’s emergency services. Do not wait for a report to be reviewed on this platform.',
        details: ['Emergency number: 999'],
        actions: [
          {
            label: 'Call Emergency Services',
            href: 'tel:999',
            type: 'phone',
            primary: true
          }
        ]
      },
      {
        name: 'Talian HEAL 15555',
        audience: 'Emotional and psychosocial support.',
        description: 'Feeling overwhelmed, distressed, or emotionally affected by bullying? Reach out for psychosocial support and help navigating a difficult situation.',
        details: [
          'Telephone: 15555',
          'Hours: 8:00 AM–12:00 midnight daily, including public holidays.'
        ],
        note: 'This service is not available 24 hours a day. If there is immediate danger, call 999.',
        actions: [
          {
            label: 'Call Talian HEAL',
            href: 'tel:15555',
            type: 'phone',
            primary: true
          },
          {
            label: 'Official service information',
            href: 'https://sites.google.com/moh.gov.my/ncemh/talian-sokongan-psikososial',
            type: 'external'
          }
        ]
      },
      {
        name: 'Befrienders Kuala Lumpur',
        audience: 'For people experiencing distress, loneliness, or emotional difficulties.',
        description: 'You do not have to face difficult feelings alone. Befrienders offers emotional support and someone who will listen.',
        details: [
          'Telephone: 03-7627 2929',
          'Availability: 24 hours daily.'
        ],
        actions: [
          {
            label: 'Call Befrienders',
            href: 'tel:+60376272929',
            type: 'phone',
            primary: true
          },
          {
            label: 'Befrienders website',
            href: 'https://www.befrienders.org.my/',
            type: 'external'
          },
          {
            label: 'Contact page',
            href: 'https://www.befrienders.org.my/contact-us/',
            type: 'external'
          }
        ]
      }
    ]
  },
  {
    id: 'protection-welfare',
    title: 'Protection and welfare',
    description: 'Help with abuse, neglect, violence, and welfare concerns.',
    resources: [
      {
        name: 'Talian Kasih 15999',
        audience: 'For abuse, child neglect, domestic violence, sexual harassment, and welfare-related concerns.',
        description: 'If bullying is connected to abuse, neglect, violence, or a need for welfare and protection assistance, Talian Kasih can help connect you with relevant support.',
        details: [
          'Telephone: 15999',
          'WhatsApp: 019-261 5999',
          'Availability: 24 hours daily.'
        ],
        actions: [
          {
            label: 'Call Talian Kasih',
            href: 'tel:15999',
            type: 'phone',
            primary: true
          },
          {
            label: 'WhatsApp Talian Kasih',
            href: 'https://wa.me/60192615999',
            type: 'whatsapp'
          },
          {
            label: 'Official website',
            href: 'https://www.kpwkm.gov.my/portal-main/article?id=talian-kasih',
            type: 'external'
          },
          {
            label: 'Malaysia government information',
            href: 'https://www.malaysia.gov.my/en/digital-services/panggilan-talian-kasih-15999',
            type: 'external'
          }
        ]
      },
      {
        name: 'Women’s Aid Organisation (WAO)',
        audience: 'For women experiencing domestic violence, abuse, and related safety concerns.',
        description: 'If bullying is accompanied by abuse, threats, or violence against women, WAO may provide information, support, and guidance on available options.',
        details: [
          'WAO Hotline: 03-3000 8858',
          'TINA WhatsApp / SMS: 018-988 8058',
          'TINA availability: 24 hours.'
        ],
        note: 'WAO focuses on violence against women and related support. It is not a general bullying complaint service.',
        actions: [
          {
            label: 'Call WAO Hotline',
            href: 'tel:+60330008858',
            type: 'phone',
            primary: true
          },
          {
            label: 'WhatsApp / SMS TINA',
            href: 'https://wa.me/60189888058',
            type: 'whatsapp'
          },
          {
            label: 'WAO website',
            href: 'https://wao.org.my/',
            type: 'external'
          },
          {
            label: 'Services and contact details',
            href: 'https://wao.org.my/our-services/',
            type: 'external'
          }
        ]
      }
    ]
  },
  {
    id: 'mental-health',
    title: 'Mental health support',
    description: 'Emotional support, mental health information, and professional services.',
    resources: [
      {
        name: 'Malaysian Mental Health Association (MMHA)',
        audience: 'Mental health information, support, and related services.',
        description: 'Bullying can affect emotional well-being, self-confidence, and mental health. MMHA provides information about mental health support and available services.',
        details: [
          'Telephone: 03-2780 6803',
          'Hours: Monday–Friday, 9:00 AM–5:00 PM, excluding public holidays.'
        ],
        actions: [
          {
            label: 'Explore Mental Health Support',
            href: 'https://mmha.org.my/find-help',
            type: 'external',
            primary: true
          },
          {
            label: 'Call MMHA 03-2780 6803',
            href: 'tel:+60327806803',
            type: 'phone'
          }
        ]
      }
    ]
  },
  {
    id: 'more-support',
    title: 'More support resources',
    description: 'Additional organisations and community resources. Check each organisation’s services to see whether they fit your needs.',
    resources: [
      {
        name: 'MERCY Malaysia',
        audience: 'Humanitarian assistance and related programmes.',
        description: 'MERCY Malaysia is a humanitarian organisation involved in health-related and humanitarian programmes. Contact the organisation to ask whether it can assist with your particular needs.',
        details: [
          'Telephone: 03-2276 2116',
          'Hours: Monday–Friday, 9:00 AM–6:00 PM.'
        ],
        note: 'This is a general contact number, not a dedicated bullying or mental health crisis hotline.',
        actions: [
          {
            label: 'Visit MERCY Malaysia',
            href: 'https://mercy.org.my/',
            type: 'external',
            primary: true
          },
          {
            label: 'Call 03-2276 2116',
            href: 'tel:+60322762116',
            type: 'phone'
          }
        ]
      },
      {
        name: 'Bully-Free Malaysia Community',
        audience: 'Community awareness and connection.',
        description: 'Visit the community group for updates and community discussion. Avoid sharing private information or identifying details about children.',
        actions: [
          {
            label: 'Visit Facebook Community',
            href: 'https://www.facebook.com/groups/bullyfreemalaysia',
            type: 'external',
            primary: true
          }
        ]
      }
    ]
  }
];